"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _axios = _interopRequireDefault(require("axios"));

var _lodash = _interopRequireDefault(require("lodash"));

var _basic = _interopRequireDefault(require("./_basic"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getErrorMessage = function getErrorMessage(e) {
  var responseData = _lodash.default.get(e, 'response.data');

  var errorMessage = _lodash.default.get(e, 'message');

  var responseError = _lodash.default.get(responseData, 'error', responseData);

  return _lodash.default.isString(responseError) ? responseError : _lodash.default.isEmpty(responseError) ? errorMessage : JSON.stringify(responseError);
};

var HitlSLSApi =
/*#__PURE__*/
function (_BasicApi) {
  (0, _inherits2.default)(HitlSLSApi, _BasicApi);

  /**
   * Represents a HitL SLS Api.
   * @constructor
   */
  function HitlSLSApi(_ref) {
    var _this;

    var userTokenFactory = _ref.userTokenFactory,
        hitlApiUrl = _ref.hitlApiUrl,
        accountId = _ref.accountId,
        timeout = _ref.timeout;
    (0, _classCallCheck2.default)(this, HitlSLSApi);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(HitlSLSApi).call(this, {
      userTokenFactory: userTokenFactory
    }));
    _this.hitlApiUrl = hitlApiUrl;
    _this.accountId = accountId;
    _this.axios = _axios.default.create(_objectSpread({}, timeout && {
      timeout: timeout
    }));
    return _this;
  }

  (0, _createClass2.default)(HitlSLSApi, [{
    key: "getUrl",
    value: function getUrl(url) {
      return "".concat(this.hitlApiUrl, "/api/v1/").concat(url);
    }
  }, {
    key: "_callApi",
    value: function () {
      var _callApi2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(_ref2) {
        var url, data, queryParams, method, _ref3, response;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = _ref2.url, data = _ref2.data, queryParams = _ref2.queryParams, method = _ref2.method;
                _context.next = 3;
                return this.axios({
                  url: this.getUrl(url),
                  method: method,
                  data: data,
                  params: _lodash.default.mapValues(queryParams, function (value) {
                    return _lodash.default.isArray(value) ? JSON.stringify(value) : value;
                  }),
                  headers: {
                    Authorization: this.userToken,
                    'Content-Type': 'application/json;charset=UTF-8'
                  }
                }).catch(function (e) {
                  throw new Error(getErrorMessage(e));
                });

              case 3:
                _ref3 = _context.sent;
                response = _ref3.data;
                return _context.abrupt("return", response);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _callApi(_x) {
        return _callApi2.apply(this, arguments);
      }

      return _callApi;
    }()
    /**
     * @param {String} param0.filterId id of filter
     * @returns {Object} filter
     */

  }, {
    key: "getFilter",
    value: function () {
      var _getFilter = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(_ref4) {
        var filterId;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                filterId = _ref4.filterId;
                return _context2.abrupt("return", this._callApi({
                  method: 'get',
                  url: '/filters',
                  queryParams: {
                    filterId: filterId
                  }
                }));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getFilter(_x2) {
        return _getFilter.apply(this, arguments);
      }

      return getFilter;
    }()
    /**
     * @returns {Array} filters list
     */

  }, {
    key: "getFilters",
    value: function () {
      var _getFilters = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3() {
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", this._callApi({
                  method: 'get',
                  url: '/filters'
                }));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getFilters() {
        return _getFilters.apply(this, arguments);
      }

      return getFilters;
    }()
    /**
     * @param {String} param0.name name of filter
     * @param {Boolean} param1.isCommon common or personal filter
     * @param {Object} param2.settings filter settings
     * @param {Boolean} param3.isDefault default for apply common filter
     * @param {Number} param4.order order of filter
     * @returns {Object} added filter
     */

  }, {
    key: "createFilter",
    value: function () {
      var _createFilter = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee4(_ref5) {
        var name, isCommon, settings, isDefault, order;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                name = _ref5.name, isCommon = _ref5.isCommon, settings = _ref5.settings, isDefault = _ref5.isDefault, order = _ref5.order;
                return _context4.abrupt("return", this._callApi({
                  method: 'post',
                  url: '/filters',
                  data: {
                    name: name,
                    isCommon: isCommon,
                    settings: settings,
                    isDefault: isDefault,
                    order: order
                  }
                }));

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function createFilter(_x3) {
        return _createFilter.apply(this, arguments);
      }

      return createFilter;
    }()
    /**
     * @param {String} param0.filterId id of filter
     * @param {String} param1.name name of filter
     * @param {Boolean} param2.isCommon common or personal filter
     * @param {Object} param3.settings filter settings
     * @param {Boolean} param4.isDefault default for apply common filter
     * @param {Number} param5.order order of filter
     * @returns {Object} added filter
     */

  }, {
    key: "updateFilter",
    value: function () {
      var _updateFilter = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee5(_ref6) {
        var filterId, name, isCommon, settings, isDefault, order;
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                filterId = _ref6.filterId, name = _ref6.name, isCommon = _ref6.isCommon, settings = _ref6.settings, isDefault = _ref6.isDefault, order = _ref6.order;
                return _context5.abrupt("return", this._callApi({
                  method: 'put',
                  url: '/filters',
                  data: {
                    filterId: filterId,
                    name: name,
                    isCommon: isCommon,
                    settings: settings,
                    isDefault: isDefault,
                    order: order
                  }
                }));

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function updateFilter(_x4) {
        return _updateFilter.apply(this, arguments);
      }

      return updateFilter;
    }()
    /**
     * @param {String} param0.filterId id of filter
     * @returns {Object} delete stats
     */

  }, {
    key: "deleteFilter",
    value: function () {
      var _deleteFilter = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee6(_ref7) {
        var filterId;
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                filterId = _ref7.filterId;
                return _context6.abrupt("return", this._callApi({
                  method: 'delete',
                  url: '/filters',
                  queryParams: {
                    filterId: filterId
                  }
                }));

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function deleteFilter(_x5) {
        return _deleteFilter.apply(this, arguments);
      }

      return deleteFilter;
    }()
    /**
     * @param {Array} param0.categories categories of settings
     * @param {Boolean} param1.isCommon is common setting
     * @returns {Array} agents settings (notifications, rwsAssistant)
     */

  }, {
    key: "getSettings",
    value: function () {
      var _getSettings = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee7(_ref8) {
        var categories, isCommon;
        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                categories = _ref8.categories, isCommon = _ref8.isCommon;
                return _context7.abrupt("return", this._callApi({
                  method: 'get',
                  url: '/settings',
                  queryParams: {
                    categories: categories,
                    isCommon: isCommon
                  }
                }));

              case 2:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getSettings(_x6) {
        return _getSettings.apply(this, arguments);
      }

      return getSettings;
    }()
    /**
     * @param {Boolean} param0.isCommon is common setting
     * @param {Object} param1.data settings data
     * @returns {Object} create/update stats
     */

  }, {
    key: "createOrUpdateSettings",
    value: function () {
      var _createOrUpdateSettings = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee8(_ref9) {
        var isCommon, data;
        return _regenerator.default.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                isCommon = _ref9.isCommon, data = _ref9.data;
                return _context8.abrupt("return", this._callApi({
                  method: 'put',
                  url: '/settings',
                  queryParams: {
                    isCommon: isCommon
                  },
                  data: {
                    data: data
                  }
                }));

              case 2:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function createOrUpdateSettings(_x7) {
        return _createOrUpdateSettings.apply(this, arguments);
      }

      return createOrUpdateSettings;
    }()
    /**
     * @param {Array} param0.categories categories of canned message
     * @param {Boolean} param1.isCommon is common canned message
     * @param {Boolean} param2.ignoreRuleTags ignore rule tags in logic of canned message list
     * @returns {Array} canned messages list
     */

  }, {
    key: "getCannedMessagesList",
    value: function () {
      var _getCannedMessagesList = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee9(_ref10) {
        var categories, isCommon, ignoreRuleTags;
        return _regenerator.default.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                categories = _ref10.categories, isCommon = _ref10.isCommon, ignoreRuleTags = _ref10.ignoreRuleTags;
                return _context9.abrupt("return", this._callApi({
                  method: 'get',
                  url: '/canned-messages',
                  queryParams: {
                    categories: categories,
                    isCommon: isCommon,
                    ignoreRuleTags: ignoreRuleTags
                  }
                }));

              case 2:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function getCannedMessagesList(_x8) {
        return _getCannedMessagesList.apply(this, arguments);
      }

      return getCannedMessagesList;
    }()
    /**
     * @param {String} param0.messageId id of canned message
     * @returns {Object} canned message
     */

  }, {
    key: "getCannedMessage",
    value: function () {
      var _getCannedMessage = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee10(_ref11) {
        var messageId;
        return _regenerator.default.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                messageId = _ref11.messageId;
                return _context10.abrupt("return", this._callApi({
                  method: 'get',
                  url: '/canned-messages',
                  queryParams: {
                    messageId: messageId
                  }
                }));

              case 2:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function getCannedMessage(_x9) {
        return _getCannedMessage.apply(this, arguments);
      }

      return getCannedMessage;
    }()
    /**
     * @param {String} param0.text text of canned message
     * @param {String} param1.label short description of canned message
     * @param {Array} param2.category category of canned message
     * @param {Boolean} param3.isCommon is common canned message
     * @param {Array} param4.ruleTags tags that allow to get message
     * @param {String} param5.fileKeys file name attached to message
     * @returns {Object} added canned message
     */

  }, {
    key: "createCannedMessage",
    value: function () {
      var _createCannedMessage = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee11(_ref12) {
        var text, label, category, isCommon, ruleTags, fileKeys;
        return _regenerator.default.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                text = _ref12.text, label = _ref12.label, category = _ref12.category, isCommon = _ref12.isCommon, ruleTags = _ref12.ruleTags, fileKeys = _ref12.fileKeys;
                return _context11.abrupt("return", this._callApi({
                  method: 'post',
                  url: '/canned-messages',
                  data: {
                    text: text,
                    label: label,
                    category: category,
                    isCommon: isCommon,
                    ruleTags: ruleTags,
                    fileKeys: fileKeys
                  }
                }));

              case 2:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function createCannedMessage(_x10) {
        return _createCannedMessage.apply(this, arguments);
      }

      return createCannedMessage;
    }()
    /**
     * @param {String} param0.messageId id of canned message
     * @param {String} param1.text text of canned message
     * @param {String} param2.label short description of canned message
     * @param {Array} param3.category category of canned message
     * @param {Array} param4.ruleTags tags that allow to get message
     * @param {String} param5.fileKeys file name attached to message
     * @returns {Object} update stats
     */

  }, {
    key: "updateCannedMessage",
    value: function () {
      var _updateCannedMessage = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee12(_ref13) {
        var messageId, text, label, category, ruleTags, fileKeys;
        return _regenerator.default.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                messageId = _ref13.messageId, text = _ref13.text, label = _ref13.label, category = _ref13.category, ruleTags = _ref13.ruleTags, fileKeys = _ref13.fileKeys;
                return _context12.abrupt("return", this._callApi({
                  method: 'put',
                  url: '/canned-messages',
                  data: {
                    messageId: messageId,
                    text: text,
                    label: label,
                    category: category,
                    ruleTags: ruleTags,
                    fileKeys: fileKeys
                  }
                }));

              case 2:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function updateCannedMessage(_x11) {
        return _updateCannedMessage.apply(this, arguments);
      }

      return updateCannedMessage;
    }()
    /**
     * @param {String} param0.messageId id of canned message
     * @returns {Object} delete stats
     */

  }, {
    key: "deleteCannedMessage",
    value: function () {
      var _deleteCannedMessage = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee13(_ref14) {
        var messageId;
        return _regenerator.default.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                messageId = _ref14.messageId;
                return _context13.abrupt("return", this._callApi({
                  method: 'delete',
                  url: '/canned-messages',
                  queryParams: {
                    messageId: messageId
                  }
                }));

              case 2:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function deleteCannedMessage(_x12) {
        return _deleteCannedMessage.apply(this, arguments);
      }

      return deleteCannedMessage;
    }()
  }]);
  return HitlSLSApi;
}(_basic.default);

var _default = HitlSLSApi;
exports.default = _default;